export const allColors = [
  [207, 81, 80],     // Indian red
  [170, 255, 50],     // Green yellow
  [242, 73, 189],    // Deep pink]
  [161, 141, 127],    // Rosy brown
  [171, 160, 127],    // Burlywood
  [77, 194, 147],     // Medium aquamarine
  [142, 148, 127],    // Dark khaki
  [186, 234, 186],    // Light green
  [127, 152, 127],    // Dark sea green
  [77, 186, 77],      // Medium sea green
  [94, 255, 94],      // Light green
  [48, 73, 28],       // Dark olive green
  [210, 255, 180],    // Pale green
  [180, 235, 110],    // Yellow green
  [150, 250, 185],    // Light green
  [200, 255, 180],    // Pale green
  [194, 229, 89],     // Yellow green
  [0, 171, 176]       // Dark cyan
];

// red
export const cacColors = [
  [255, 0, 0],    // Bright red
  [0, 0, 255],    // Bright blue
  [255, 255, 0],  // Yellow
  [0, 255, 0],    // Bright green
  [255, 165, 0],  // Orange
  // [75, 0, 130],   // Indigo
  // [238, 130, 238], // Violet
  // [0, 255, 255],  // Cyan
  // [255, 20, 147], // Deep pink
  // [139, 69, 19],  // Saddle brown
  // [0, 128, 128],  // Teal
  // [128, 0, 128],  // Purple
  // [210, 105, 30], // Chocolate
  // [0, 128, 0],    // Green
  // [70, 130, 180], // Steel blue
  // [255, 215, 0],  // Gold
  // [0, 191, 255],  // Deep sky blue
  // [220, 20, 60],  // Crimson
  // [46, 139, 87],  // Sea green
  // [123, 104, 238],// Medium slate blue
  // [64, 224, 208], // Turquoise
];
export const centers = localStorage.getItem("centers")
  ? JSON.parse(localStorage.getItem("centers"))
  : [];

const apidictionary = {
  aarthi: "https://cac-test.urologiq.ai/server/api",
};

// If a key exists in the dictionary, return its value.
// If not, return the defined value (a common i18n pattern).
const apihandler = {
  get: function (target, prop) {
    // Check if the property exists on the target (our dictionary)
    if (prop in target) {
      return target[prop];
    }
    // Otherwise, return the property name itself as the fallback
    return "//cac-test.urologiq.ai/server/api";
  },
};

// 3. Create the Proxy object
export const apiURLs = new Proxy(apidictionary, apihandler);

const inferdictionary = {
  aarthi: "https://cac-test.urologiq.ai/server/infer",
};

// If a key exists in the dictionary, return its value.
// If not, return the defined value (a common i18n pattern).
const inferhandler = {
  get: function (target, prop) {
    // Check if the property exists on the target (our dictionary)
    if (prop in target) {
      return target[prop];
    }
    // Otherwise, return the property name itself as the fallback
    return "//cac-test.urologiq.ai/server/infer";
  },
};

// 3. Create the Proxy object
export const inferURLs = new Proxy(inferdictionary, inferhandler);

const ohifdictionary = {
  aarthi: "https://cac-test.urologiq.ai/server/ohif_viewer/ohif",
};

// If a key exists in the dictionary, return its value.
// If not, return the defined value (a common i18n pattern).
const ohifhandler = {
  get: function (target, prop) {
    // Check if the property exists on the target (our dictionary)
    if (prop in target) {
      return target[prop];
    }
    // Otherwise, return the property name itself as the fallback
    return "https://surgical.urologiq.ai/ohif_viewer/ohif";
  },
};

// 3. Create the Proxy object
export const ohifURLs = new Proxy(ohifdictionary, ohifhandler);

export const analyticsAPIs = {
  testinference: "https://cac-test.urologiq.ai/server/api/analytics",
};